export default "__VITE_ASSET__00ae74e5__"